<template>
  <div
    class="notification-holder"
    :style="`background-color:${
      notification.seen_at ? '#e3e3e3' : colors[notification.notification_type]
    }`"
  >
    <!-- New Apt Request -->
    <div v-if="notification.notification_type === 'new_request'">
      <span
        class="notification-text-holder"
        :style="`background-color:${
          notification.seen_at ? '#fff' : colors[notification.notification_type]
        }; color:${notification.seen_at ? '#000' : '#fff '}`"
        >NEW REQUEST</span
      >You have an Apt Request from
      <strong>{{
        notification.appointment_pass.student_user.name
          ? notification.appointment_pass.student_user.name
          : notification.appointment_pass.student_user.first_name +
            " " +
            notification.appointment_pass.student_user.last_name
      }}</strong>
      at
      <strong style="word-break: keep-all; white-space: nowrap">
        {{
          $helpers.transformDate(
            notification.appointment_pass.for_date,
            "h:mm A"
          )
        }}</strong
      >
      for
      {{ $helpers.transformDate(notification.appointment_pass.for_date) }}.
    </div>

    <!-- Canceled Apt Request -->
    <div v-if="notification.notification_type === 'canceled'">
      <span
        class="notification-text-holder"
        :style="`background-color:${
          notification.seen_at ? '#fff' : colors[notification.notification_type]
        }; color:${notification.seen_at ? '#000' : '#fff '}`"
        >CANCELED</span
      >Your Apt Request from
      <strong>{{
        notification.appointment_pass.student_user.name
          ? notification.appointment_pass.student_user.name
          : notification.appointment_pass.student_user.first_name +
            " " +
            notification.appointment_pass.student_user.last_name
      }}</strong>
      at
      <strong style="word-break: keep-all; white-space: nowrap">
        {{
          $helpers.transformDate(
            notification.appointment_pass.for_date,
            "h:mm A"
          )
        }}</strong
      >
      for
      {{ $helpers.transformDate(notification.appointment_pass.for_date) }}
      has been cancelled by
      <strong
        >{{
          notification.updated_by
            ? notification.updated_by.first_name +
              " " +
              notification.updated_by.last_name
            : "Somebody"
        }}.</strong
      >
    </div>

    <!-- Recurrence Canceled Apt Request -->
    <div v-if="notification.notification_type === 'recurrence_canceled'">
      <span
        class="notification-text-holder"
        :style="`background-color:${
          notification.seen_at ? '#fff' : colors[notification.notification_type]
        }; color:${notification.seen_at ? '#000' : '#fff '}`"
        >RECURRENCE CANCELED</span
      >Your Apt with
      <strong>{{
        notification.appointment_pass.student_user.name
          ? notification.appointment_pass.student_user.name
          : notification.appointment_pass.student_user.first_name +
            " " +
            notification.appointment_pass.student_user.last_name
      }}</strong>
      has been canceled for
      {{
        $helpers.transformDate(
          notification?.payload?.recurrence_cancel_start_date ??
            notification?.appointment_pass?.for_date
        )
      }}
      at
      <strong style="word-break: keep-all; white-space: nowrap">
        {{
          $helpers.transformDate(
            notification.appointment_pass.for_date,
            "h:mm A"
          )
        }}</strong
      >
      and all future occurrences by
      <strong
        >{{
          notification.updated_by
            ? notification.updated_by.first_name +
              " " +
              notification.updated_by.last_name
            : "Somebody"
        }}.</strong
      >
    </div>

    <!-- Time Change Apt Request -->
    <div v-if="notification.notification_type === 'time_change'">
      <span
        class="notification-text-holder"
        :style="`background-color:${
          notification.seen_at ? '#fff' : colors[notification.notification_type]
        }; color:${notification.seen_at ? '#000' : '#fff '}`"
        >EDITED</span
      >Your Apt Request from
      <strong>{{
        notification.appointment_pass.student_user.name
          ? notification.appointment_pass.student_user.name
          : notification.appointment_pass.student_user.first_name +
            " " +
            notification.appointment_pass.student_user.last_name
      }}</strong>
      at
      <strong style="word-break: keep-all; white-space: nowrap">
        {{ $helpers.transformDate(notification.old_time, "h:mm A") }}</strong
      >
      for {{ $helpers.transformDate(notification.old_time) }} has been
      <strong
        >moved to
        {{ $helpers.transformDate(notification.new_time, "h:mm A") }}
        for {{ $helpers.transformDate(notification.new_time) }}</strong
      >
      by
      <strong
        >{{
          notification.updated_by
            ? notification.updated_by.first_name +
              " " +
              notification.updated_by.last_name
            : "Somebody"
        }}.</strong
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "AdultAppointmentNotification",
  props: {
    notification: {
      type: Object,
      required: true
    }
  },
  setup() {
    const colors = {
      new_request: "#4a7cab",
      canceled: "#8a8fdf",
      time_change: "#efd4bc",
      recurrence_canceled: "#f5a623"
    }

    return { colors }
  }
}
</script>
